export default __webpack_public_path__ + "static/media/1.bb6ad6ba.jpg";